import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
import { Suspense, lazy, useMemo } from "react";
//#region src/use-bottom-overlay.tsx
var LazyBottomOverlay = lazy(() => import("./bottom-overlay-DphVR6DR.js").then((n) => n.n).then((module) => ({ default: module.BottomOverlay })));
function BottomOverlay({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "bottom-overlay" }),
		children: /* @__PURE__ */ jsx(LazyBottomOverlay, { ...props })
	});
}
function BottomOverlayContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "bottom-overlay" }),
		children: /* @__PURE__ */ jsx(LazyBottomOverlay, { ...props })
	});
}
var useBottomOverlayContent = () => {
	return useMemo(() => ({ bottomOverlay: { component: BottomOverlayContent } }), []);
};
//#endregion
export { BottomOverlay, useBottomOverlayContent };
